import models from '../static/img/models@2x.png';
import model3 from '../static/img/model3@2x.png';
import modelx from '../static/img/modelx@2x.png';
import modely from '../static/img/modely@2x.png';

const carImages = {
    models,
    model3,
    modelx,
    modely
}

export default carImages;
